// extracted by mini-css-extract-plugin
export var centerText = "_bn-8";
export var container = "_bn-0";
export var doughnutContainer = "_bn-7";
export var legend = "_bn-a";
export var legendItemColorDisplay = "_bn-b";
export var legendItemLabel = "_bn-c";
export var lg = "_bn-5";
export var maxWidth = "_bn-9";
export var md = "_bn-4";
export var responsive = "_bn-6";
export var sm = "_bn-3";
export var xs = "_bn-2";
export var xxs = "_bn-1";